export default {
  "b2b.smlouva-vytvoreni.title.vytvoreni": "New Contract",
  "b2b.smlouva-vytvoreni.title.edit": "Edit Contract",
  "b2b.smlouva-vytvoreni.field.cislo.label": "Contract Number",
  "b2b.smlouva-vytvoreni.field.popis.label": "Description",
  "b2b.smlouva-vytvoreni.field.fixMo.label": "Fixed Requirements for STR",
  "b2b.smlouva-vytvoreni.field.fixVo.label": "Fixed Requirements for LTR",
  "b2b.smlouva-vytvoreni.field.platnostOd.label": "Validity From",
  "b2b.smlouva-vytvoreni.field.platnostDo.label": "Validity To",
  "b2b.smlouva-vytvoreni.button.submit-vytvoreni": "Create",
  "b2b.smlouva-vytvoreni.button.submit-edit": "Save",
  "b2b.smlouva-vytvoreni.button.cancel": "Cancel",
  "b2b.smlouva-vytvoreni.save-dialog.title": "Save Contract"
};
